import React from "react";
import { Link, useLocation } from "react-router-dom";
import { formatPhone } from "utils/phone";
import SlideoutEnabledContext from "pages/waitlist-update/context";
import { WaitlistUpdateRequestStatus } from "types/gql-types";
import { Button } from "components/haven-design/buttons";

const STATUS_REASON: Record<WaitlistUpdateRequestStatus, string> = {
  [WaitlistUpdateRequestStatus.ALL_BOUNCED]: "All messages bounced",
  [WaitlistUpdateRequestStatus.NO_RESPONSE]: "No response",
  [WaitlistUpdateRequestStatus.RESPONDED]: "Responded",
  [WaitlistUpdateRequestStatus.UNREACHABLE]: "No address/phone/email",
  [WaitlistUpdateRequestStatus.UNREACHABLE_LANDLINE_ONLY]: "Landline only",
};

export const NameColumnRaw: React.FC<{
  interestId: string, name: string | null, onViewSlideout?: () => void}> =
 ({ interestId, name, onViewSlideout }) => {
   const location = useLocation();
   const { slideoutEnabled } = React.useContext(SlideoutEnabledContext);

   if (slideoutEnabled) {
     // get current path and if it has interests/:interestId/update, remove from interests beyond
     const path = location.pathname;
     const interestsIndex = path.indexOf("/interests/");
     const pathToUpdate = interestsIndex > -1 ? path.substring(0, interestsIndex) : path;
     const normalizedBase = pathToUpdate.replace(/\/+$/, "");
     return (
       <Link to={`${normalizedBase}/interests/${interestId}/update`} onClick={() => {
         onViewSlideout?.();
       }}>
         {name ?? "Missing Name"}
       </Link>
     );
   }
   return (
     <a href={`/dash/manager/interest/${interestId}/activity`} rel="noreferrer" target="_blank">
       {name ?? "Missing Name"}
     </a>
   );
 };

export const PhoneColumn: React.FC<{value: string}> = ({ value }) =>
  <span>{formatPhone(value)}</span>;

export const ReasonColumn: React.FC<{status: string}> = ({ status }) => (
  <span>{STATUS_REASON[status as WaitlistUpdateRequestStatus]}</span>
);

export const ContactColumn: React.FC<{onContact:() => void }> =
 ({ onContact }) => (
   <Button color="secondary" size="S" onClick={onContact}>
     Contact
   </Button>
 );
